function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 5.79999C9.49375 5.79999 10.5 6.80624 10.5 8.04999C10.5 9.29374 9.49375 10.3 8.25 10.3C7.00625 10.3 6 9.29374 6 8.04999C6 6.80624 7.00625 5.79999 8.25 5.79999ZM6 2.54999C6 3.79374 7.00625 4.79999 8.25 4.79999C9.49375 4.79999 10.5 3.79374 10.5 2.54999C10.5 1.30624 9.49375 0.299988 8.25 0.299988C7.00625 0.299988 6 1.30624 6 2.54999ZM6 13.55C6 14.7937 7.00625 15.8 8.25 15.8C9.49375 15.8 10.5 14.7937 10.5 13.55C10.5 12.3062 9.49375 11.3 8.25 11.3C7.00625 11.3 6 12.3062 6 13.55Z",
  fill: "white"
});

var SvgIconPreviewMenuMobile = function SvgIconPreviewMenuMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPreviewMenuMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_preview_menu_mobile.d1b9af30.svg";
export { ForwardRef as ReactComponent };